<template>
    <div>
        <div class="container-fluid">
            <!-- Head -->
            <div class="d-flex align-items-center justify-content-between pt-4 mb-4">
                <div class="d-block">
                    <div class="h1-lg display-tektur m-0">Rasionalisasi</div>
                </div>
                <div class="d-block">
                    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-with-progress-bar" ref="openModalGenerateRank"></button>
                    <button type="button" class="btn btn-primary btn-lg btn-s-1 me-2" @click="generateLocalRankConfirm()" v-if="dataList.length > 0">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-cog fa-lg me-3"></i>Generate Rank</div>
                    </button>
                    <button type="button" v-on:click="$router.push({ name: 'import_score' })" class="btn btn-primary btn-lg btn-s-1 me-2">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-file-excel fa-lg me-3"></i>Import Nilai</div>
                    </button>
                    <button type="button" v-on:click="goToPage()" class="btn btn-primary btn-lg btn-s-1">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-circle-plus fa-lg me-3"></i>Tambah Data</div>
                    </button>
                </div>
            </div>

            <div id="cardList">
                <div class="card">
                    <div class="card-header py-3">
                        <div class="input-group input-group-flush input-group-merge input-group-reverse">
                            <input class="form-control list-search" type="search" placeholder="Cari data disini..." v-model="keywords" v-on:keyup.enter="getData(1)">
                                <span class="input-group-text">
                                <i class="fa-solid fa-search"></i>
                            </span>
                        </div>
                        
                        <div class="d-flex align-items-center">
                            <div class="d-block me-3 text-muted">Filter:</div>
                            <div class="d-block me-2" style="width:200px;">
                                <div class="form-select-wrapper">
                                    <v-select
                                        :options="dataUniversity"
                                        label="name"
                                        v-model="filter.university"
                                        placeholder="Semua Universitas"
                                        append-to-body
                                        @input='set_university'
                                        >
                                    </v-select>
                                </div>
                            </div>
                            <div class="d-block me-2" style="width:200px;">
                                <div class="form-select-wrapper">
                                    <v-select
                                        :options="dataMajor"
                                        label="name"
                                        v-model="filter.major"
                                        placeholder="Semua Jurusan"
                                        append-to-body
                                        @input='set_major'
                                        >
                                    </v-select>
                                </div>
                            </div>
                            <div class="d-block" style="width:250px;">
                                <div class="form-select-wrapper">
                                    <v-select
                                        :options="dataYear"
                                        label="name"
                                        v-model="filter.graduation_year"
                                        placeholder="Semua Tahun Lulus"
                                        append-to-body
                                        @input='set_graduation_year'
                                        >
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center" style="margin-left:10px !important">
                            <div class="d-block me-3 text-muted">Urut berdasarkan:</div>
                            <div class="d-bloc me-2" style="width:200px;">
                                <select class="form-select form-select-dark" v-model="sort_rank" v-on:change="getData()">
                                    <option value="">Urutkan Rangking</option>
                                    <option value="asc">Ranking Terkecil ke terbesar</option>
                                    <option value="desc">Ranking Terbesar ke terkecil</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!dataFetch && dataList.length > 0"  class="list fs-base">
                    <div v-for="(item, index) in dataList" :key="index" class="card bg-card-trans">
                        <div class="card-body">
                            <div class="row g-3">
                                <div class="col-12 col-xl-4">
                                    <div class="d-flex flex-column h-100">
                                        <div class="d-flex align-items-start mb-3 flex-1">
                                            <div class="d-block me-3">
                                                <div class="avatar avatar-sm">
                                                    <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden">
                                                <div class="d-block h2 mb-1 display-tektur block-ellipsis">{{ item.fullname }}</div>
                                                <div class="d-block text-sm">Kelas <span class="text-pink font-bold">{{ item.class }}</span></div>
                                                <div class="d-block text-sm">Tahun Lulus <span class="text-pink font-bold">{{ item.graduation_year }}</span></div>
                                                <div class="d-block mt-1" v-if="!item.university_one && !item.major_one">
                                                    <span class="badge bg-warning text-dark"><i class="fa-solid fa-circle-info me-2"></i>Draft dari import nilai, lengkapi Biodata</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-auto">
                                                <div class="d-flex px-3 text-sm py-2 border rounded align-items-center justify-content-between">
                                                    <div class="d-block text-nowrap me-3">Rank Sekolah</div>
                                                    <div class="d-block text-pink font-bold">{{ item.rank_school }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-xl-8">
                                    <div class="row g-3">
                                        <div class="col-12 col-lg" v-for="(itemDetail, indexDetail) in item.rationalization_score" :key="indexDetail">
                                            <div class="d-block border rounded h-100">
                                                <div class="row h-100">
                                                    <div class="col border-end">
                                                        <div class="d-block p-3">
                                                            <div class="d-block mb-3 font-bold text-neon">
                                                                <i class="fa-solid fa-caret-right me-2"></i>
                                                                Pilihan {{indexDetail+1}}
                                                            </div>
                                                            <div class="d-block">
                                                                <div class="d-block font-bold">{{ itemDetail.university_name }}</div>
                                                                <div class="d-block text-sm">{{ itemDetail.major_name }}</div>
                                                                <div class="d-flex align-items-center justify-content-start mt-2" v-if="item.graduation_status == 0 && item.generate == 1">
                                                                    <div class="form-check">
                                                                        <input class="form-check-input" type="checkbox" :name="'graduation_status_'+indexDetail" @change="setGraduation(item.id, indexDetail, itemDetail.university_id, itemDetail.major_id, item.fullname, itemDetail.university_name, itemDetail.major_name)" true-value="1" false-value="0">
                                                                        <label class="form-check-label mt-2">Diterima SNBP</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="mt-1" v-if="item.graduation_status == 1">
                                                                <div v-if="item.pass_at_university == itemDetail.university_id && item.pass_at_major == itemDetail.major_id">
                                                                    <span class="badge bg-primary"><i class="fa-solid fa-crown me-2"></i>Jurusan Diterima</span>
                                                                    <span class="badge bg-success text-dark mt-1"><i class="fa-solid fa-check-circle me-2"></i>Diterima jalur SNBP</span>
                                                                    <span class="badge bg-danger text-white mt-1"><a href="javascript:void(0)" @click="removeGraduation(item.id, indexDetail, itemDetail.university_id, itemDetail.major_id, item.fullname, itemDetail.university_name, itemDetail.major_name)" class="text-white"><i class="fa-solid fa-trash me-2"></i>Hapus Status Lolos</a></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-auto border-end ps-0 pe-0">
                                                        <div class="d-block p-3 text-center">
                                                            <div class="d-block mb-3">
                                                                Peluang
                                                            </div>
                                                            <div class="d-block h1 display-tektur m-0 text-pink">
                                                                {{ itemDetail.score_data.opportunity ? itemDetail.score_data.opportunity :'-' }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-auto ps-0">
                                                        <div class="d-block p-3 text-center">
                                                            <div class="d-block mb-3">
                                                                Ranking
                                                            </div>
                                                            <div class="d-block h1 display-tektur m-0 text-pink">
                                                                {{ itemDetail.score_data.rank.my_rank ? itemDetail.score_data.rank.my_rank : '-' }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Kotak Nilai TKA di-hide sementara (hapus v-if untuk menampilkan lagi) -->
                                        <div v-if="false" class="col-12 col-lg-auto">
                                            <div class="d-block border rounded h-100">
                                                <div class="row h-100">
                                                    <div class="col">
                                                        <div class="d-block p-3">
                                                            <div class="d-block mb-3 font-bold text-neon text-nowrap">
                                                                <i class="fa-solid fa-caret-right me-2"></i>
                                                                Nilai TKA
                                                            </div>
                                                            <div class="d-block text-center">
                                                                <div class="d-block h1 display-tektur m-0 text-pink">{{item.average_score_tka}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="d-flex align-items-center justify-content-end">
                                <button v-if="item.graduation_status == 0" type="button" class="btn btn-white-naked btn-sm me-2" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Edit" data-bs-original-title="Edit" v-on:click="goToPage(item.code)">
                                    <i class="fa-solid fa-pencil"></i>
                                </button>
                                <button v-if="item.graduation_status == 0" v-on:click="deleteData(item.id)" type="button" class="btn btn-white-naked btn-sm text-danger me-3" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Delete" data-bs-original-title="Delete">
                                    <i class="fa-solid fa-trash-can"></i>
                                </button>
                                <a href="javascript:void(0)" v-on:click="goToPage(item.code)" type="button" class="btn btn-white btn-sm">Detail<i class="fa-solid fa-arrow-right ms-2"></i></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!dataFetch && dataList.length > 0"  class="card">
                    <div aria-label="navigation" class="card-footer d-flex justify-content-between">
                        <!-- Pagination (prev) -->
                        <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                            <li class="page-item">
                                <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('prev')">
                                    <i class="fa-solid fa-angle-left me-3"></i>Sebelumnya
                                </a>
                            </li>
                        </ul>

                        <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" v-on:change="getData(pagination.current_page)"></v-pagination>

                        <!-- Pagination (next) -->
                        <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                            <li class="page-item">
                                <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('next')">
                                    Selanjutnya<i class="fa-solid fa-angle-right ms-3"></i>
                                </a>
                            </li>
                        </ul>

                    </div>
                </div>

                <div class="card" v-if="dataFetch">
                    <div class="card-body">
                        <div class="d-block text-center py-4">
                            <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                            <div class="d-block text-sm text-muted ">Loading...</div>
                        </div>
                    </div>
                </div>

                <div class="card" v-if="!dataFetch && emptyState">
                    <div class="card-body">
                        <div class="d-block text-center py-4">
                            <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                            <div class="d-block text-sm text-muted ">Data tidak ditemukan, mohon untuk mencoba memuat ulang kembali.</div>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'
export default {
    name: 'RationalizationMain',
    metaInfo: {
        title: 'Rasionalisasi',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        vPagination
    },
    data() {
        return {
            filter : {
                graduation_year : [],
                university : [],
                major      : []
            },
            emptyState  : false,
            dataFetch   : false,
            dataList    : [],
            keywords    : "",
            group       : "rapor",
            tabActive   : 'tab_rapor',
            pagination: {
                current_page    : 1,
                total_pages     : 0,
                limit           : 50,
                style: {
                    ul: 'list-pagination pagination pagination-tabs card-pagination',
                    li: 'page-item',
                    a: 'page',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'                
                },
                anchor_text: {
                    first: '',
                    prev: '',
                    next: '',
                    last: ''
                }
            },
            dataYear : [],
            dataUniversity : [],
            university_id : '',
            dataMajor : [],
            major_id : '',
            graduation_year : '',
            sort_rank : 'asc',
            generateProgress: 0,
            generateQueue: 0
        }
    },
    created() {       
        this.getYear();
        this.getUniversity();
        this.getMajor();
        this.changeTab(this.tabActive);
    },
    methods: {
        changeTab: function(params="") {
            this.tabActive = params;

            if(this.tabActive == 'tab_rapor') {
                this.group = 'rapor';
            } else {
                this.group = 'utbk';
            }

            // this.getData();
        },
        getData: function(page=1) {
            this.pagination.current_page = page
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/list';

            this.dataFetch  = true;                
            this.$http.get(uri,{
                params : {
                    keywords    : this.keywords,
                    page        : this.pagination.current_page,
                    limit       : this.pagination.limit,
                    tab_active  : this.tabActive,
                    group       : this.group,
                    university_id   : this.university_id,
                    major_id   : this.major_id,
                    sort_rank : this.sort_rank,
                    graduation_year : this.graduation_year
                }
            }).then(res => {
                this.emptyState                 = false;
                this.dataFetch                  = false;                
                this.dataList                   = res.data.data.list;
                this.pagination.total_pages     = res.data.total_page;
                this.generateQueue              = res.data.data.total_all_rationalization;

                if(this.dataList.length < 1) {
                    this.emptyState = true;
                }
            });
        },
        pagination_handle: function(params) {
            if(params == 'next') {
                if(this.pagination.current_page < this.pagination.total_pages) {
                    this.pagination.current_page = this.pagination.current_page+1;
                    this.getData(this.pagination.current_page);
                }
            }

            if(params == 'prev') {
                if(this.pagination.current_page > 1) {
                    this.pagination.current_page = this.pagination.current_page-1;
                    this.getData(this.pagination.current_page);
                }
            }
        },
        editData: function(id="", group="") {
            if(group == 'rapor') {
                document.getElementById('btn-close-modal-passing-grade-alumni-detail').click();
                this.$parent.$parent.passing_grade_alumni_form(id)
            } else {
                document.getElementById('btn-close-modal-passing-grade-alumni-utbk-detail').click();
                this.$parent.$parent.passing_grade_alumni_utbk_form(id)
            }
        },
        deleteData: function (id) {
            this.$swal({
                icon: 'info',
                title: 'Hapus Data',
                text: 'Apakah kamu yakin ingin menghapus data ini?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/delete', {
                    id: id
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.getData(this.pagination.current_page);
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
        },
        setGraduation: function(id, number, university_id, major_id, fullname, university_name, major_name) {
            this.$swal({
                icon: 'info',
                title: 'Konfirmasi',
                html: 'apakah anda yakin akan mengubah status kelulusan : <strong>'+fullname+'</strong><br/>Universitas: '+university_name+'<br/>Jurusan: '+major_name+'</i> ?',
                confirmButtonText: 'Konfirmasi',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
                if (result.value) {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/set-graduation', {
                        id: id,
                        university_id: university_id,
                        major_id: major_id,
                        fullname: fullname
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.getData();
                                }
                            });
                        } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: response.data.message,
                        });
                        }
                    })
                } else {
                    document.querySelector('[name="graduation_status_'+number+'"]').checked = false;
                }
            });
        },
        removeGraduation: function(id, number, university_id, major_id, fullname, university_name, major_name) {
            this.$swal({
                icon: 'info',
                title: 'Konfirmasi',
                html: 'apakah anda yakin akan menghapus status kelulusan : <strong>'+fullname+'</strong><br/>Universitas: '+university_name+'<br/>Jurusan: '+major_name+'</i> ?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
                if (result.value) {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/set-graduation', {
                        id: id,
                        university_id: university_id,
                        major_id: major_id,
                        remove : 1
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.getData();
                                }
                            });
                        } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: response.data.message,
                        });
                        }
                    })
                }
            });
        },
        goToPage: function(params=null) {
            if(params == null) {
                this.$router.push( {
                    name : 'rationalization_form_add'
                })
            } else {
                this.$router.push({
                    name : 'rationalization_form_edit',
                    params: { code: params }
                });
            }
        },
        getYear: function() {
            let uri         = process.env.VUE_APP_APIHOST+'year/list';
            this.$http.get(uri).then(res => {
                this.dataYear = res.data.data;

                this.dataYear.forEach(element => {
                    if(element.active == 1) {
                        this.filter.graduation_year = element;
                        this.set_graduation_year();
                    }
                });
            });
        },
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getMajor: function() {
            this.major_id = "";
            let uri         = process.env.VUE_APP_APIHOST+'master-major/list';
            this.$http.get(uri).then(res => {
                this.dataMajor = res.data.data;
            });
        },
        set_university: function() {
            if (this.filter.university !== undefined && this.filter.university !== null) {
                this.university_id = this.filter.university.id;
            }  else {
                this.university_id = "";
            }
            this.getData();
        },
        set_major: function() {
            if (this.filter.major !== undefined && this.filter.major !== null) {
                this.major_id = this.filter.major.id;
            }  else {
                this.major_id = "";
            }
            this.getData();
        },
        set_graduation_year: function() {
            if (this.filter.graduation_year !== undefined && this.filter.graduation_year !== null) {
                this.graduation_year = this.filter.graduation_year.id;
            }  else {
                this.graduation_year = "";
            }
            this.getData();
        },
        generateLocalRankConfirm: function () {
            this.$swal({
                icon: 'info',
                title: 'Generate Ranking Sekolah',
                text: 'Kamu akan meng-generate ranking sekolah berdasarkan data rapor yang ada. Lanjutkan proses ini?',
                confirmButtonText: 'Generate',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
                if (result.value) {
                    this.$refs.openModalGenerateRank.click();
                    this.$parent.$parent.openModalWithProgressBar({
                        title: 'Generate Ranking Sekolah',
                        subtitle: 'Proses generate ranking sekolah sedang berlangsung...',
                        progress: 0,
                        withClose: false,
                        action : this.generateLocalRank,
                    })
                }
            });
        },
        async generateLocalRank(page=1) {
            const limit         = 5;
            const currPage      = this.generateQueue / limit;

            this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/generate-local-rank', {
                page            : page,
                limit           : limit,
                group           : this.group,
                university_id   : this.university_id,
                major_id        : this.major_id,
                sort_rank       : this.sort_rank,
                graduation_year : this.graduation_year
            })
            .then(response => {
                if (response.data.status) {
                    if (page < currPage) {
                        this.generateProgress = Math.round((page / currPage) * 100);
                        this.generateLocalRank(page + 1);
                        this.$parent.$parent.updateProgressBar(this.generateProgress);
                    } else {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        });
                        this.getData();
                        this.$parent.$parent.updateProgressBar(100);
                        this.$parent.$parent.updateSubtitleModalWithProgressBar(response.data.message);
                        this.$parent.$parent.updateCloseModalWithProgressBar(true);
                    }
                } else {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: response.data.message,
                });
                }
            })
        }
    }
}
</script>